import getHash from './getHash';
import { session as browserSessionStorage } from './browserStorage';

class BrowserTabId {
  constructor() {
    if (!this.get() || !this.wasTabUnloaded()) {
      this.set();
    }
    window.addEventListener('beforeunload', this.onPageUnload.bind(this));
    window.addEventListener('unload', this.onPageUnload.bind(this));
    this.setTabUnloaded(false);
  }

  async set() {
    browserSessionStorage.set(browserSessionStorage.KEYS.browserTabId, await getHash(Date.now().toString()));
  }

  get() {
    return browserSessionStorage.get(browserSessionStorage.KEYS.browserTabId);
  }

  setTabUnloaded(wasUnloaded: boolean) {
    browserSessionStorage.set(browserSessionStorage.KEYS.wasBrowserTabUnloaded, wasUnloaded);
  }

  onPageUnload() {
    this.setTabUnloaded(true);
  }

  wasTabUnloaded() {
    return browserSessionStorage.get(browserSessionStorage.KEYS.wasBrowserTabUnloaded);
  }
}

export default new BrowserTabId();
